import React from 'react';
import { DatePicker } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import { DateFormat } from '../../../constants/dateFormat';

interface IGlobalDatepickerprops {
    value: string[]
    onChange: ((dates: any, dateStrings: string[]) => void) | undefined;
    maxDate: Dayjs
}

const GlobalDatepicker = (props: IGlobalDatepickerprops) => {
    const { value, onChange, maxDate } = props

    const { RangePicker } = DatePicker;

    const rangeValue = value.map((dateStr: string) => dayjs(dateStr, DateFormat.MM_DD_YYYY)) as [Dayjs, Dayjs];

    return (
        <RangePicker
            onChange={onChange}
            allowClear={false}
            showToday={false}
            format={DateFormat.MM_DD_YYYY}
            value={rangeValue}
            maxDate={maxDate}
        />
    )
}

export default GlobalDatepicker